import { render } from "./CreateShipment.vue?vue&type=template&id=fa41135e&scoped=true"
import script from "./CreateShipment.vue?vue&type=script&lang=js"
export * from "./CreateShipment.vue?vue&type=script&lang=js"

import "./CreateShipment.vue?vue&type=style&index=0&id=fa41135e&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2981498683/src/lrex-site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fa41135e"]])

export default __exports__